import type {IApplicationDefinition} from '@apps-config/app-definition'
import {Application as MDUMApplication} from '@applications/mobile-data-usage-meter'
import {
  mobileDataUsageMeterReducer,
  MobileDataUsageMeterAction,
} from '@telstra-connect/mobile-data-usage-meter/reducers'
import {loadFeatureFlags as loadMDUMFeatureFlags} from '@telstra-connect/mobile-data-usage-meter/feature-flags/load-flags'
import {platformAppName} from '@telstra-connect/utils/data/platform-data'
import {ApplicationName as MDUMAppName} from '@telstra-connect/mobile-data-usage-meter/activity-tracking'
import type {IFeatureFlags as IDashboardFlags} from '@telstra-connect/dashboard/feature-flags/common'
import type {IMobilityState} from '@telstra-connect/mobile-data-usage-meter/state'
import type {IFeatureFlags as MDUMFlags} from '@telstra-connect/mobile-data-usage-meter/feature-flags/common'
import {setFeatureFlags} from '@apps-config/feature-flags'
import '../node_modules/telstra-ui/resources/telstraui.css'
import '../node_modules/telstra-ui/resources/themes/pacific.css'
import './index.scss'
import {enableLogging} from '@utils/logger'
enableLogging()

loadMDUMFeatureFlags()

export function getRedesignTilesPhase2() {
  // eslint-disable-next-line dot-notation, @typescript-eslint/dot-notation
  const servicesConfig = window['applications']
  if (servicesConfig == null) {
    return false
  }
  if (
    typeof servicesConfig[platformAppName] === 'object' &&
    servicesConfig[platformAppName].redesignTilesPhase2
  ) {
    return true
  }
  return false
}

export interface IGlobalMapProps {
  width?: number | string
  height?: number | string
  className?: string
}

function getMobileDataUsageApplication() {
  setFeatureFlags()
  return MDUMApplication
}

function getMobileDataUsageReducer() {
  return (mobileDataUsageMeterReducer as unknown) as IMobilityState
}

type TGetSessionDetails = () => {sessionId: string}

interface IApplications {
  [platformAppName]?: IDashboardFlags
  [MDUMAppName]?: MDUMFlags
  ['Billing']?: object
}

declare const global: {
  TCONN: {
    getSessionDetails: TGetSessionDetails
    Platform: {
      isSecureAuth: boolean
      resolveTargetURL: (targetURL: string) => string
    }
    Mobility: {
      GetApplication: () => IApplicationDefinition
      GetReducers: (state: IMobilityState, action: MobileDataUsageMeterAction) => IMobilityState
    }
  }
  applications: IApplications
}

global.TCONN = {...global.TCONN}

global.TCONN.Mobility = {
  GetApplication: getMobileDataUsageApplication,
  GetReducers: getMobileDataUsageReducer,
}

export default global
